import { render, staticRenderFns } from "./FriendZone.vue?vue&type=template&id=6d39e87c&scoped=true&"
import script from "./FriendZone.vue?vue&type=script&lang=js&"
export * from "./FriendZone.vue?vue&type=script&lang=js&"
import style0 from "./FriendZone.vue?vue&type=style&index=0&id=6d39e87c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d39e87c",
  null
  
)

export default component.exports